











import { Component, Vue, Prop } from 'vue-property-decorator';
import { DocumentNode } from 'graphql';
import i18n from '@/i18n';
import { FetchPolicy } from 'apollo-client';

@Component
export default class ShowPdfButton extends Vue {
  private pdfLoading = false;
  @Prop(Object) private query!: DocumentNode;
  @Prop(Object) private variables!: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  @Prop({ type: String, default: 'cache-first' }) private fetchPolicy!: FetchPolicy;
  @Prop({type: Function, required: true}) private getPdf!: (data: unknown) => {url: string};

  private showPdf() {
    this.pdfLoading = true;
    // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
    const generatingPdfMessage = this.$sMessage.warning(i18n.t('Document.pdfGenerating'), { duration: 0 });
    this.$apollo.query({
      query: this.query,
      fetchPolicy: this.fetchPolicy,
      variables: this.variables,
    }).then(({ data }) => {
      this.$sMessage.close(generatingPdfMessage.id);
      if (this.getPdf(data).url) {
        window.open(this.getPdf(data).url, '_blank');
      } else {
        // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
        this.$sMessage.warning(i18n.t('Document.pdfNotCreatedYet'));
      }
    }).finally(() => {
      this.pdfLoading = false;
    });
  }
}
